export default "__VITE_ASSET__BljhHIAT__"